exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".XYysOLojapKVAy{position:absolute;top:0;right:0;z-index:10;margin-top:4px}", ""]);

// exports
exports.locals = {
	"closeButton": "XYysOLojapKVAy"
};